interface ParcelLabel {
    alias?: string | null;
    parcelLocation: {
        name: string;
        number: string | number;
    };
}

export default function parcel(value: ParcelLabel | null | undefined): string {

    if(!value) {

        return '';
    }

    let result = `${value.parcelLocation.name} ${value.parcelLocation.number}`;

    if(value.alias) {

        result += ` - ${value.alias}`;
    }

    return result;
}
